import {EActionNames, EFruits} from "src/store/enums";
import {ID} from "src/store/models";

export interface IAddShelf {
    type: EActionNames.ADD_SHELF;
    payload: string;
}

export function addShelf(id: string): IAddShelf {
    return {
        payload: id,
        type: EActionNames.ADD_SHELF
    }
}

export interface IAddBox {
    type: EActionNames.ADD_BOX;
    payload: IAddBoxPayload;
}

export interface IAddBoxPayload {
    shelfId: ID;
    boxId: ID;
    defaultKind?: string;
    defaultSize?: number;
}

export function addBox({shelfId, boxId, defaultKind, defaultSize}: IAddBoxPayload): IAddBox {
    return {
        payload: {
            boxId,
            defaultKind,
            defaultSize,
            shelfId
        },
        type: EActionNames.ADD_BOX
    }
}

export interface IAddFruit {
    type: EActionNames.ADD_FRUIT;
    payload: IAddFruitPayload;
}

export interface IAddFruitPayload {
    fruitId: ID;
    boxId: ID;
    kind?: EFruits;
    size?: number;
}

export function addFruit({boxId, fruitId, kind, size}: IAddFruitPayload): IAddFruit {
    return {
        payload: {
            boxId,
            fruitId,
            kind,
            size
        },
        type: EActionNames.ADD_FRUIT
    }
}

export interface IChangeContainerPayload {
    elementId: ID;
    targetId: ID;
}

export interface IChangeContainer {
    type: EActionNames.CHANGE_CONTAINER;
    payload: IChangeContainerPayload;
}

export function changeContainerOfElement({elementId, targetId}: IChangeContainerPayload): IChangeContainer {
    return {
        payload: {
            elementId,
            targetId
        },
        type: EActionNames.CHANGE_CONTAINER
    }
}

export interface IChangeTreePayload {
    treeIsMapped: boolean;
}

export interface IChangeTree {
    type: EActionNames.CHANGE_TREE_MAPPED;
    payload: IChangeTreePayload;
}

export function changeTreeMapped(): IChangeTree {
    return {
        payload: {
            treeIsMapped: true
        },
        type: EActionNames.CHANGE_TREE_MAPPED
    }
}

export interface IChangeDraggingElementPayload {
    id: ID;
    type: string;
}

export interface IChangeDraggingElement {
    type: EActionNames.CHANGE_DRAGGING_ELEMENT,
    payload: IChangeDraggingElementPayload
}

export function changeDraggingElement({id, type}: IChangeDraggingElementPayload): IChangeDraggingElement {
    return {
        payload: {
            id,
            type
        },
        type: EActionNames.CHANGE_DRAGGING_ELEMENT
    }
}

export interface ISortElementsPayload {
    shelfId: ID;
}

export interface ISortElements {
    type: EActionNames.SORT_ELEMENTS,
    payload: ISortElementsPayload
}

export function sortElementsOnShelf({shelfId}: ISortElementsPayload): ISortElements {
    return {
        payload: {
            shelfId
        },
        type: EActionNames.SORT_ELEMENTS
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.ts